import React, { createContext, useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import { firestore } from './FirebaseContext';

export const EmpaqueContext = createContext({
  generateEmpaqueUser: () => {},
  getEmpaqueItemsOwnerUser: () => {},
  empaqueUser: {}
});

function EmpaqueProvider({ children }) {
  const [empaqueUser, setEmpaqueUser] = useState(null);
  const { user, isAuthenticated } = useAuth();

  // console.log('empaquetado', empaqueUser);
  // const getEmpaqGeneral = async () => {
  //   const data = [];
  //   firestore
  //     .collection('empaquetado')
  //     .get()
  //     .then((query) => {
  //       query.forEach((doc) => {
  //         data.push({ id: doc.id, ...doc.data() });
  //       });
  //     });

  //   return data;
  // };

  const getEmpaqueItemsOwnerUser = (userId, setState) => {
    firestore
      .collection('empaquetado_user')
      .doc(userId)
      .onSnapshot((doc) => {
        if (doc.exists) {
          setState(doc.data());
        }
      });
  };

  const generateEmpaqueUser = async (userId) => {
    const res = await firestore.collection('empaquetado_user').doc(userId).set({
      id: userId,
      status: 'active',
      empaqueItems: [],
      created_date: new Date(),
      updated_date: new Date()
    });

    return res;
  };

  const addEmpaqueSurtidoReport = async (userId, items) => {
    const res = await (await firestore.collection('empaquetado_user').doc(userId).get()).data();

    const itemsActual = res.empaqueItems;

    let arrItemResult = [...res.empaqueItems];
    // eslint-disable-next-line no-restricted-syntax
    for (const item of items) {
      const finded = itemsActual.find((it) => it.id === item.id);

      if (finded) {
        const obj = {
          ...finded,
          existencia: Number(finded.existencia) + Number(item.cantidad)
        };

        const filtered = arrItemResult.filter((it) => it.id !== finded.id);

        arrItemResult = [...filtered, obj];
      } else {
        const obj = {
          id: item.id,
          name: item.name,
          img: item.img,
          existencia: item.cantidad,
          minStock: 30,
          maxStock: 100
        };

        arrItemResult.push(obj);
      }
    }

    console.log('el array resultante', arrItemResult);

    return firestore.collection('empaquetado_user').doc(userId).update({ empaqueItems: arrItemResult });
  };

  useEffect(() => {
    async function getData() {
      await firestore
        .collection('empaquetado_user')
        .doc(user.id)
        .onSnapshot((snapshot) => {
          if (snapshot.exists) {
            setEmpaqueUser(snapshot.data());
          }
        });
    }

    if (isAuthenticated) {
      getData();
    }
    // dispatch(getProducts());
  }, [isAuthenticated, user.id]);
  return (
    <EmpaqueContext.Provider
      value={{ generateEmpaqueUser, getEmpaqueItemsOwnerUser, empaqueUser, addEmpaqueSurtidoReport }}
    >
      {children}
    </EmpaqueContext.Provider>
  );
}

export default EmpaqueProvider;
